import { useEffect, useState } from "react";
import { ArrowRightLeft, KeyRound, History, Coins, Pencil, Trash2, RefreshCw, Send, Calendar, Mail, UserPlus, UserCog } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const ICONS = { customer_transfer: ArrowRightLeft, pin_reset: KeyRound, password_reset: KeyRound, settlement: Coins, order_edit: Pencil, order_delete: Trash2, order_status: RefreshCw, order_send_production: Send, closed_date: Calendar, client_notify: Mail, email_settings: Mail, user_create: UserPlus, user_role: UserCog, user_active: UserCog, user_dual_role: UserCog, user_contact: UserCog };
const LABELS = { customer_transfer: "Transfer klienta", pin_reset: "Reset PIN", password_reset: "Reset hasła", settlement: "Rozliczenie", order_edit: "Edycja zamówienia", order_delete: "Usunięcie zamówienia", order_status: "Zmiana statusu", order_send_production: "Do produkcji", closed_date: "Data zamknięcia", client_notify: "E-mail do klienta", email_settings: "Ustawienia e-mail", user_create: "Nowy użytkownik", user_role: "Zmiana roli", user_active: "Aktywacja konta", user_dual_role: "Podwójna rola", user_contact: "Dane kontaktowe" };

const fmt = (iso) => {
  try {
    return new Date(iso).toLocaleString("pl-PL", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};

export const AuditLog = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/audit").then((r) => setLogs(r.data)).catch((e) => toast.error(errMsg(e))).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="p-8 text-center font-medium text-muted-foreground">Ładowanie…</div>;

  return (
    <div className="space-y-4" data-testid="audit-view">
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <History className="h-4 w-4 text-amber-400" />
        Dziennik operacji: edycje i usuwanie zamówień, zmiany statusów, transfery klientów, resety haseł, rozliczenia premii. Zapisanych zdarzeń: {logs.length}.
      </div>
      {logs.length === 0 ? (
        <div data-testid="audit-empty" className="rounded-xl border border-dashed border-border p-12 text-center font-semibold text-muted-foreground">Brak zapisanych operacji.</div>
      ) : (
        <div className="rounded-xl border border-border bg-card overflow-x-auto">
          <table className="w-full text-sm min-w-[680px]" data-testid="audit-table">
            <thead className="bg-secondary text-muted-foreground font-mono text-[11px] uppercase tracking-wider">
              <tr>
                <th className="text-left px-4 py-2.5 w-40">Data</th>
                <th className="text-left px-3 py-2.5 w-40">Operacja</th>
                <th className="text-left px-3 py-2.5">Szczegóły</th>
                <th className="text-left px-3 py-2.5 w-40">Użytkownik</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((l) => {
                const Icon = ICONS[l.action] || History;
                return (
                  <tr key={l.id} data-testid={`audit-row-${l.id}`} className="border-t border-border hover:bg-accent/50 align-top">
                    <td className="px-4 py-3 font-mono text-xs whitespace-nowrap">{fmt(l.ts)}</td>
                    <td className="px-3 py-3">
                      <span className="inline-flex items-center gap-1.5 rounded-md border border-amber-500/30 bg-amber-400/10 px-2 py-0.5 text-[11px] font-bold uppercase tracking-wider text-amber-300">
                        <Icon className="h-3.5 w-3.5" />{LABELS[l.action] || l.action}
                      </span>
                    </td>
                    <td className="px-3 py-3 font-medium">{l.summary}</td>
                    <td className="px-3 py-3 text-muted-foreground">{l.actor_name}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
